import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MusicTapeIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.5 5.5H10.5C11.3284 5.5 12 6.17157 12 7C12 7.82843 11.3284 8.5 10.5 8.5H5.5C4.67157 8.5 4 7.82843 4 7C4 6.17157 4.67157 5.5 5.5 5.5ZM6 7C6 7.41421 5.66421 7.75 5.25 7.75C4.83579 7.75 4.5 7.41421 4.5 7C4.5 6.58579 4.83579 6.25 5.25 6.25C5.66421 6.25 6 6.58579 6 7ZM10.75 7.75C11.1642 7.75 11.5 7.41421 11.5 7C11.5 6.58579 11.1642 6.25 10.75 6.25C10.3358 6.25 10 6.58579 10 7C10 7.41421 10.3358 7.75 10.75 7.75Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.10899 3.54601C1 3.75992 1 4.03995 1 4.6V11.4C1 11.9601 1 12.2401 1.10899 12.454C1.20487 12.6422 1.35785 12.7951 1.54601 12.891C1.75992 13 2.03995 13 2.6 13H3.88191C4.0713 13 4.24443 12.893 4.32913 12.7236L4.77634 11.8292C5.03043 11.321 5.54982 11 6.11798 11H9.88191C10.4501 11 10.9695 11.321 11.2236 11.8292L11.6708 12.7236C11.7555 12.893 11.9286 13 12.118 13H13.4C13.9601 13 14.2401 13 14.454 12.891C14.6422 12.7951 14.7951 12.6422 14.891 12.454C15 12.2401 15 11.9601 15 11.4V4.6C15 4.03995 15 3.75992 14.891 3.54601C14.7951 3.35785 14.6422 3.20487 14.454 3.10899C14.2401 3 13.9601 3 13.4 3H2.6C2.03995 3 1.75992 3 1.54601 3.10899C1.35785 3.20487 1.20487 3.35785 1.10899 3.54601ZM3 7C3 5.61929 4.11929 4.5 5.5 4.5H10.5C11.8807 4.5 13 5.61929 13 7C13 8.38071 11.8807 9.5 10.5 9.5H5.5C4.11929 9.5 3 8.38071 3 7Z"
		></path>
		<path
			fill="currentColor"
			d="M10.3291 12.2764C10.4954 12.6088 10.2536 13 9.88192 13H6.11798C5.74629 13 5.50454 12.6088 5.67077 12.2764C5.75546 12.107 5.9286 12 6.11798 12H9.88191C10.0713 12 10.2444 12.107 10.3291 12.2764Z"
		></path>
	</svg>
))
